import { Link } from "react-router-dom";
import client1 from "../../../assets/img/client/client-1.avif";
import client2 from "../../../assets/img/client/hpcl.webp";
import client3 from "../../../assets/img/client/iocl.jpg";
import client4 from "../../../assets/img/client/indore.png";
import client5 from "../../../assets/img/client/NUPPL.jpg";
import client6 from "../../../assets/img/client/RCF.jpg";
import client7 from "../../../assets/img/client/CPCL.jpg";
import client8 from "../../../assets/img/client/pwd.webp";

const OurClients = () => {
  return (
    <>
      <section className="sectionPD pb-0">
        <div className="container">
          <div className="fisherman-content">
            <h6>Our Clients</h6>
            <h3>Trusted by These Brands</h3>

              <div className="clientMarquee">
                <ul>
                  <li>
                    <img src={client1} alt="Trusted by These Brands" />
                  </li>
                  <li>
                    <img src={client2} alt="Trusted by These Brands" />
                  </li>
                  <li>
                    <img src={client3} alt="Trusted by These Brands" />
                  </li>
                  <li>
                    <img src={client4} alt="Trusted by These Brands" />
                  </li>
                  <li>
                    <img src={client5} alt="Trusted by These Brands" />
                  </li>
                  <li>
                    <img src={client6} alt="Trusted by These Brands" />
                  </li>
                  <li>
                    <img src={client7} alt="Trusted by These Brands" />
                  </li>
                  <li>
                    <img src={client8} alt="Trusted by These Brands" />
                  </li>
                </ul>
              </div>
            <Link to="/clients" className="commonButton">View More</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default OurClients;
